var _circle, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEmail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 48,
    viewBox: "0 0 49 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 24.5612,
    cy: 23.7727,
    r: 22.2447,
    transform: "rotate(-90 24.5612 23.7727)",
    stroke: "black",
    strokeWidth: 3.05489
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.4545 18.411C18.0064 18.411 17.6364 18.7628 17.6364 19.1888V28.5221C17.6364 28.9481 18.0064 29.2999 18.4545 29.2999H31.5455C31.9936 29.2999 32.3636 28.9481 32.3636 28.5221V19.1888C32.3636 18.7628 31.9936 18.411 31.5455 18.411H18.4545ZM16 19.1888C16 17.9037 17.1027 16.8555 18.4545 16.8555H31.5455C32.8973 16.8555 34 17.9037 34 19.1888V28.5221C34 29.8072 32.8973 30.8555 31.5455 30.8555H18.4545C17.1027 30.8555 16 29.8072 16 28.5221V19.1888Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.148 19.1873C16.4071 18.8354 16.9173 18.7498 17.2874 18.9961L25 24.1283L32.7126 18.9961C33.0827 18.7498 33.5929 18.8354 33.852 19.1873C34.1112 19.5392 34.0211 20.0241 33.6509 20.2705L25.4692 25.7149C25.1875 25.9023 24.8125 25.9023 24.5308 25.7149L16.3491 20.2705C15.9789 20.0241 15.8888 19.5392 16.148 19.1873Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmail);
export default __webpack_public_path__ + "static/media/email.37dfe513.svg";
export { ForwardRef as ReactComponent };